module.exports = __webpack_public_path__ + "img/10.8d2db6b5.jpg";